/**
 * Surcharges des actions Shopify pour ce store :
 * - updateCart : evenements emis depuis le tiroir panier maison.
 * - openCart   : ouvre le tiroir maison (repli sur /cart s'il est absent).
 *
 * Le tiroir Horizon natif (theme-drawer#cart-drawer) a ete retire le 2026-08-31 ;
 * le tiroir reel est .ch-cart-drawer, rendu par sections/ch-header.liquid, qui
 * expose window.chOpenCart.
 */

function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.updateCart.configure({
    eventTarget: () => document.querySelector('.ch-cart-drawer') ?? document,
  });

  actions.openCart.configure({
    async handler() {
      if (typeof window.chOpenCart === 'function') {
        window.chOpenCart();
      } else {
        window.location.href = Theme.routes.cart_url || '/cart';
      }
    },
  });
}

// Run immediately if the standard-actions bundle has already attached
// `Shopify.actions`; otherwise wait for DOMContentLoaded, which fires after
// all module scripts have executed regardless of document order.
if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}
